import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface NavItem {
  path: string;
  label: string;
  icon: string;
  activeIcon: string;
}

const navItems: NavItem[] = [
  { path: '/home', label: 'home', icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill' },
  { path: '/market', label: 'market', icon: 'ri-line-chart-line', activeIcon: 'ri-line-chart-fill' },
  { path: '/lock-price', label: 'lockPrice', icon: 'ri-lock-line', activeIcon: 'ri-lock-fill' },
  { path: '/orders', label: 'orders', icon: 'ri-file-list-3-line', activeIcon: 'ri-file-list-3-fill' },
  { path: '/profile', label: 'profile', icon: 'ri-user-line', activeIcon: 'ri-user-fill' },
];

export default function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation(['common']);
  const currentPath = location.pathname;

  const hidePaths = ['/', '/login', '/register', '/forgot-password', '/deposit', '/privacy', '/terms'];
  if (hidePaths.includes(currentPath)) return null;
  if (currentPath.startsWith('/admin')) return null;
  if (currentPath.startsWith('/profile/')) return null;
  if (currentPath.startsWith('/orders/perform') || currentPath.startsWith('/orders/storage')) return null;

  return (
    <>
      {/* Floating pill nav */}
      <div
        className="fixed z-50 left-1/2 -translate-x-1/2 flex items-center bg-white/95 backdrop-blur-md rounded-full"
        style={{
          bottom: 'max(16px, env(safe-area-inset-bottom))',
          width: 'min(92%, 400px)',
          height: '64px',
          boxShadow: '0 8px 32px rgba(0,0,0,0.12), 0 2px 8px rgba(0,0,0,0.06)',
        }}
      >
        {navItems.map((item, index) => {
          const isActive = currentPath === item.path || currentPath.startsWith(`${item.path}/`);
          const isCenter = index === 2;

          if (isCenter) {
            return (
              <button
                key={item.path}
                onClick={() => navigate(item.path)}
                className="flex flex-col items-center justify-center gap-0.5 cursor-pointer"
                style={{ width: '20%' }}
              >
                <span
                  className={`
                    flex items-center justify-center rounded-full transition-all duration-200
                    ${isActive
                      ? 'bg-gold-500 text-white'
                      : 'text-brown-500 hover:text-brown-700'}
                  `}
                  style={{
                    width: '32px',
                    height: '32px',
                    boxShadow: isActive ? '0 4px 14px rgba(212,168,67,0.3)' : 'none',
                  }}
                >
                  <i className={`text-lg ${isActive ? item.activeIcon : item.icon}`}></i>
                </span>
                <span className={`text-[10px] leading-none transition-colors duration-200 ${isActive ? 'text-gold-600 font-medium' : 'text-brown-400'}`}>
                  {t(`common:${item.label}`)}
                </span>
              </button>
            );
          }

          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="flex flex-col items-center justify-center gap-0.5 cursor-pointer"
              style={{ width: '20%' }}
            >
              <span className={`text-xl leading-none transition-colors duration-200 ${isActive ? 'text-gold-600' : 'text-brown-500 hover:text-brown-700'}`}>
                <i className={isActive ? item.activeIcon : item.icon}></i>
              </span>
              <span className={`text-[10px] leading-none transition-colors duration-200 ${isActive ? 'text-gold-600 font-medium' : 'text-brown-400'}`}>
                {t(`common:${item.label}`)}
              </span>
            </button>
          );
        })}
      </div>
    </>
  );
}